export default "__VITE_ASSET__C9VJnvGU__"